(() => {
  const mobile = matchMedia('(max-width: 749px)');
  let frame = 0;
  let shift = 0;
  let launcher;
  function findPart(root) {
    const part = root?.querySelector('[part~="activator"]');
    if (part) return part;
    for (const node of root?.querySelectorAll('*') || []) {
      if (node.shadowRoot) {
        const found = findPart(node.shadowRoot);
        if (found) return found;
      }
    }
    return null;
  }
  function update() {
    frame = 0;
    if (!mobile.matches) {
      document.body.style.removeProperty('--oger-chat-shift');
      document.body.removeAttribute('data-oger-chat-obstructed');
      shift = 0;
      return;
    }
    const host = document.querySelector('shopify-chat');
    if (!host) return;
    if (!launcher?.isConnected) launcher = findPart(host.shadowRoot);
    if (!launcher) return;
    const box = launcher.getBoundingClientRect();
    if (!box.width || !box.height) return;
    const base = { left: box.left, right: box.right, top: box.top + shift, bottom: box.bottom + shift };
    const targets = Array.from(document.querySelectorAll('.mb-card-atc, .cv__btn, .cart__checkout-button, .product-form-buttons .add-to-cart-button, .oger-sticky-purchase:not([hidden])'))
      .map(node => node.getBoundingClientRect())
      .filter(rect => rect.width && rect.height && rect.bottom > 0 && rect.top < innerHeight);
    let chosen;
    for (const offset of [0, 72, 144, 216]) {
      const top = base.top - offset;
      const bottom = base.bottom - offset;
      if (top < 110) continue;
      const overlaps = targets.some(rect => base.left < rect.right + 8 && base.right > rect.left - 8 && top < rect.bottom + 8 && bottom > rect.top - 8);
      if (!overlaps) { chosen = offset; break; }
    }
    document.body.toggleAttribute('data-oger-chat-obstructed', chosen === undefined);
    shift = chosen ?? 0;
    document.body.style.setProperty('--oger-chat-shift', `${-shift}px`);
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  addEventListener('resize', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  document.addEventListener('cart:update', schedule);
  const observer = new MutationObserver(schedule);
  observer.observe(document.querySelector('#MainContent') || document.body, { subtree: true, childList: true });
  const chatObserver = new MutationObserver(schedule);
  chatObserver.observe(document.body, { childList: true });
  for (const delay of [0, 800, 2400, 5000]) setTimeout(schedule, delay);
})();
